import { useQuery, useQueryClient } from '@tanstack/react-query';

import { UserRelationship } from '../types/networking';
import { apiMain } from 'services/apiService';

export function useUserRelationship(userId1: string, userId2: string) {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery<UserRelationship, Error>({
    queryKey: ['userRelationship', userId1, userId2],
    queryFn: async () => {
      const res = await apiMain.get<UserRelationship>(
        `/networking/v1/relationships/${userId1}/${userId2}`
      );
      return res.data;
    },
    enabled: !!userId1 && !!userId2,
    staleTime: 1000 * 60, // 1 minute
  });

  const refresh = () => {
    queryClient.invalidateQueries({ queryKey: ['userRelationship', userId1, userId2] });
  };

  return {
    relationship: data || null,
    loading: isLoading,
    error: error?.message || null,
    refresh,
  };
}
